/**
 * The widget's locale layer.
 *
 * `cs.json` is generated from `locales.csv` by `npm run generate:locales` and is
 * never hand-edited — a missing or wrong string is a defect in the CSV. The
 * widget ships one language today; adding another means adding a column there
 * and picking the active one here, not scattering literals back through the UI.
 */
import cs from "./cs.json";

const messages = cs;

export type LocaleKey = keyof typeof messages;

/**
 * The typed key map. Keys are referenced as `Loc.someKey` rather than as bare
 * strings, so a renamed or removed row fails the typecheck instead of printing
 * the key to a customer.
 */
export const Loc = Object.fromEntries(
  Object.keys(messages).map((key) => [key, key]),
) as { [K in LocaleKey]: K };

/** `{name}` placeholders, so word order stays the translator's decision. */
export function t(
  key: LocaleKey,
  params?: Record<string, string | number>,
): string {
  const message = messages[key];
  if (!params) return message;

  return message.replace(/\{(\w+)\}/g, (placeholder, name: string) =>
    name in params ? String(params[name]) : placeholder,
  );
}
